import { searchTypeMap } from '../../manager/searchConstants';
import { createSearchObjectOptions } from '../../manager/SearchManager';
import { POI_NAME } from '../../infoblock/components/wpt/WptTagsProvider';

const SYMBOL_LAYER_TYPE = 'symbol';
const ON_PATH_SYMBOL_PLACEMENT = 'line';
const OSM_ID_TAG = 'osm_id';
const NAME_TAG = 'name';
const HOUSE_NUMBER_TAG = 'addr:housenumber';

export function pickClickableFeatures(features) {
    const byOsmId = new Map();
    features.forEach((feature) => {
        const clickable =
            feature.layer?.type === SYMBOL_LAYER_TYPE &&
            feature.layer.layout?.['symbol-placement'] !== ON_PATH_SYMBOL_PLACEMENT &&
            feature.properties?.[OSM_ID_TAG] != null;
        if (clickable && !byOsmId.has(feature.properties[OSM_ID_TAG])) {
            byOsmId.set(feature.properties[OSM_ID_TAG], feature);
        }
    });

    return [...byOsmId.values()];
}

// preview for WptDetails (name only, type and icon come from the server) + what is needed to load the details
export function createMvtObject(feature, clickLatlng) {
    const { properties, geometry } = feature;
    const osmId = properties[OSM_ID_TAG];
    // plain name, as the server returns it (amenity.getName), so the preview does not change on load
    const name = properties[NAME_TAG] ?? '';
    const isHouse = !name && Boolean(properties[HOUSE_NUMBER_TAG]);
    const [lng, lat] = geometry?.type === 'Point' ? geometry.coordinates : [clickLatlng.lng, clickLatlng.lat];

    return {
        poi: {
            key: osmId,
            options: isHouse
                ? createSearchObjectOptions(searchTypeMap.HOUSE, properties[HOUSE_NUMBER_TAG])
                : { [POI_NAME]: name },
            latlng: { lat, lng },
            mapObj: true,
        },
        mvt: {
            osmId,
            mapObjectId: feature.id,
            tags: isHouse ? null : properties,
        },
    };
}
